export default "__VITE_ASSET__Cteb5fKh__"